module.exports = __webpack_public_path__ + "img/24.48fddd95.png";